import { RouterType } from '@online-webinar/router';
import { OnDemandParticipants } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/on-demand-participants'].update({
        staticData: { title: { page: 'Insights.OnDemand.PageHeading', forWebinar: true } },
        component: authGuard(OnDemandParticipants, { canBroadcast: true })
    });
};
